import alerts from './alerts'
import common from './common'
import contacts from './contacts'
import hub from './hub'
import profile from './profile'
import shortlist from './shortlist'
import updates from './updates'

export default {
  ...common,
  ...profile,
  ...shortlist,
  ...contacts,
  ...hub,
  ...alerts,
  ...updates,
}
